// labels

export const marketLabels = {
    ID: 'INDONESIA',
    PH: 'PHILIPPINES',
    AR: 'ARGENTINA',
    EG: 'EGYPT',
};
export const categoryLabels = {
    CC: 'CONVENTIONAL CIGARETTES',
    SFP: 'SMOKE FREE PRODUCTS'
};
export const brandLabels = {
    MARLBORO: 'MARLBORO',
    MAGNUM: 'MAGNUM',
    FORTUNE: 'FORTUNE',
    LM: 'L&M'
};
